import React, {useEffect} from "react";
import Sidebar from "../../components/SideBar";
import Navbar from "../../components/NavBar";
import DbTableListTest from "../../DbTableListTest";
import {useNavigate} from "react-router-dom";

export const Tables = () => {

    const navigate = useNavigate();
    useEffect(() => {
        if (window.localStorage.getItem("auth_token") === null) navigate("/login");
    }, [navigate]);
    const token = window.localStorage.getItem("auth_token");

    return (
        <>
            {token && (<div className="d-flex">
                <div>
                    <Sidebar/>
                </div>
                <div
                    style={{
                        flex: "1 1 auto",
                        display: "flex",
                        flexFlow: "column",
                        height: "100vh",
                        overflowY: "hidden",
                    }}
                >
                    <Navbar/>
                    <div style={{height: "100%"}}>
                        <div
                            style={{
                                padding: "20px 5%",
                                height: "calc(100% - 64px)",
                                overflowY: "scroll",
                            }}
                        >
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(1, minmax(200px, 700px))",
                                }}
                            >
                                <div className="mt-5 w-100">
                                    <h4 className="font-weight-bold mb-3">Table from database</h4>
                                    <DbTableListTest/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>)}
            {!token && <div className="login-container"></div>}
        </>

    );
};
